var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReportPressed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "29px",
    viewBox: "0 0 26 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_report_pressed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 26 0 26 9.84476255 0 9.84476255"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 20.5011077 0 20.5011077 10.8155618 0 10.8155618"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_report_pressed"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 10.578618)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9679083,4.08629893 L17.2065756,4.08629893 C16.8607787,4.08629893 16.5376909,4.25971346 16.3463844,4.54839361 L14.9724871,6.62076613 L12.5126845,0.639685037 C12.3647316,0.279781061 12.0268486,0.0337663924 11.6390744,0.00314358753 C11.2478594,-0.0271351409 10.8786654,0.163139141 10.6763484,0.495172924 L8.46634535,4.12483549 L1.03222938,4.12483549 C0.461750608,4.12483549 0,4.58693018 0,5.15706487 C0,5.72754364 0.461750608,6.18929425 1.03222938,6.18929425 L9.04645826,6.18929425 C9.40636224,6.18929425 9.74046048,6.0014285 9.92798215,5.69416822 L11.3789526,3.31075059 L13.8033153,9.20512441 C13.9485156,9.55849093 14.2771086,9.80278522 14.6573131,9.83994548 C14.6910326,9.84304216 14.724408,9.84476255 14.7581275,9.84476255 C15.1018599,9.84476255 15.4259799,9.67306839 15.6179746,9.38301194 L17.7608827,6.15075768 L24.9679083,6.15075768 C25.5380429,6.15075768 26.0001376,5.688663 26.0001376,5.1185283 C26.0001376,4.54839361 25.5380429,4.08629893 24.9679083,4.08629893",
    id: "Fill-1",
    fill: "#172B4E",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(3.048827, 17.589567)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4688783,0 C18.8987436,0 18.4366489,0.462094685 18.4366489,1.03222938 L18.4366489,7.84941626 C18.4366489,8.34660674 18.032015,8.75124066 17.5351686,8.75124066 L2.96593908,8.75124066 C2.46909267,8.75124066 2.06445875,8.34660674 2.06445875,7.84941626 L2.06445875,1.03222938 C2.06445875,0.462094685 1.60236407,0 1.03222938,0 C0.462094685,0 0,0.462094685 0,1.03222938 L0,7.84941626 C0,9.48481167 1.33054367,10.8156994 2.96593908,10.8156994 L17.5351686,10.8156994 C19.170564,10.8156994 20.5011077,9.48481167 20.5011077,7.84941626 L20.5011077,1.03222938 C20.5011077,0.462094685 20.039013,0 19.4688783,0",
    id: "Fill-4",
    fill: "#172B4E",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.08105647,13.7079717 C4.65119117,13.7079717 5.11328585,13.245877 5.11328585,12.6757423 L5.11328585,5.85855546 C5.11328585,5.3610209 5.51791977,4.95638699 6.01476617,4.95638699 L20.5839957,4.95638699 C21.0808421,4.95638699 21.485476,5.3610209 21.485476,5.85855546 L21.485476,12.6757423 C21.485476,13.245877 21.9475707,13.7079717 22.5177054,13.7079717 C23.0878401,13.7079717 23.5499348,13.245877 23.5499348,12.6757423 L23.5499348,5.85855546 C23.5499348,4.22281597 22.2193911,2.89192823 20.5839957,2.89192823 L6.01476617,2.89192823 C4.37937076,2.89192823 3.0488271,4.22281597 3.0488271,5.85855546 L3.0488271,12.6757423 C3.0488271,13.245877 3.51092178,13.7079717 4.08105647,13.7079717",
    id: "Fill-7",
    fill: "#172B4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4995514,2.06445875 L15.0992793,2.06445875 C15.669414,2.06445875 16.1315087,1.60236407 16.1315087,1.03222938 C16.1315087,0.462094685 15.669414,0 15.0992793,0 L11.4995514,0 C10.9294167,0 10.467322,0.462094685 10.467322,1.03222938 C10.467322,1.60236407 10.9294167,2.06445875 11.4995514,2.06445875",
    id: "Fill-9",
    fill: "#172B4E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportPressed);
export default __webpack_public_path__ + "static/media/icon_report_pressed.b994cf4e11e4694830b8ce26ad61ce41.svg";
export { ForwardRef as ReactComponent };